//Core Module
import React, {useEffect, useState} from 'react';

//External Module
import {
    Button, Card, CardBody, CardHeader, Collapse
} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope} from "@fortawesome/free-regular-svg-icons";
import {faPencil} from "@fortawesome/free-solid-svg-icons/faPencil";
import Switch from "react-switch";

//Custom Module
import QuickReplyOperations from "../../../QuickReply/QuickReplyOperations";
import {decodeString, getWAComponents, parseJSON, randstr, showToast,handleErrorResponse, getWATemplateDetails} from "../../../../Common/Appcommon";
import requestApi from "../../../../services/requestApi.service";
import { useForm } from 'react-hook-form';

const NotificationItem = props => {
    let {notification, waTemplates, waOptions} = props;
    //let notificationId = notification[0];
    let name = notification[1];
    let description = notification[2];
    let currStatus = notification[8];
    let notificationId = notification[24];
    const [statusText, setstatusText] = useState(notification[8]);
    const [isNotification, setIsNotificationAvailable] = useState(false);
    const [isMessageModalEnabled, showMessageModal] = useState(false);
    const [selectedID, setSelectedID] = useState("");
    const [notificationFormData, setNotificationFormData] = useState({});
    const [messageText, setMessageText] = useState("Please configure WhatsApp Message.");
    
    useEffect(() => {
        (async () => {
            await getTriggerNotificationMapper(notificationId);
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);
    const getTriggerNotificationMapper = async (notificationId) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "NOTIFICATIONID" : notificationId,
            "OPERATION" : "GETNOTIFICATION_MAPPER"
        }
        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            let notificationTemplate = res.data;
            let notiFormData = {};
            if(notificationTemplate.length > 0){
                let templateId = notificationTemplate[2];
                let templateName = notificationTemplate[3];
                let components = notificationTemplate[4];
                let waTemplate = waTemplates[templateId];
                if(waTemplate != undefined){
                    let parsedComponents = waTemplate['Components'] !== undefined ? parseJSON(decodeString(waTemplate['Components'])) : {};

                    if(Object.keys(parsedComponents).length > 0){
                        let waComponents = getWAComponents(parsedComponents);
                        let bodyComponent = waComponents['BODY'];
                        let messageTxt = bodyComponent['text'];
                        setMessageText(messageTxt);
                        let selectedTemplate = {value : templateId, label : templateName};
                        notiFormData['Message'] = messageTxt;
                        notiFormData['selectedTemplate'] = selectedTemplate;
                        notiFormData['Components'] = components;
                        setNotificationFormData(notiFormData);
                        setIsNotificationAvailable(true);
                    }
                }else{
                    setIsNotificationAvailable(true);
                }
                
            } else {
                setIsNotificationAvailable(true);
            }
        }
    }
    const toggleInboxSettings = (id) => {
        if(selectedID === id){
            setSelectedID("");
        } else {
            setSelectedID(id);
        }
    }


    const editReplyMessage = () => {
        showMessageModal(true);
    }

    const onNotificationMessageSave = async (isModalClose, formData) => {
        showMessageModal(isModalClose);
        if(formData !== undefined) {
            formData['Name'] = name;
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "FORMINPUT": formData,
                "OPERATION": "notificationMapper",
                "triggerid": notificationId,
            }
            let res = await requestApi.processServerRequest(params, "WebV2", "post");
            if (res.issuccess) {
                await getTriggerNotificationMapper(notificationId);
                showToast('Whatsapp Notification Updated.');
            }else{
                handleErrorResponse(res.errormsg);
            }
        }
    }
    const changeInboxSettingsStatus = async (id, status, title) => {
        let newStatus = statusText.toLowerCase() === "active" ? "InActive" : "Active";
        let toastStatus = statusText.toLowerCase() === "active" ? "Disabled" : "Enabled";

       let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "UPDATE_WA_NOTIFICATION_STATUS",
            "STATUS" : newStatus,
            "ID" : id
        };

        let response = await requestApi.processServerRequest(params, "WebV2", "post");
        if(response.issuccess){
            setstatusText(newStatus);
            await getTriggerNotificationMapper(id);

            showToast(title+" is "+toastStatus);
        }else{
            handleErrorResponse(response.errormsg);
        }
    }
    const form = useForm();
    return (
        <div className={'mb-3 settings-container'}>
            <Card>
                <CardHeader className={'inbox-card w-100'} id={`inbox-settings-${notificationId}`}>
                    <div className={`notification-status`}>
                        <Switch onColor={"#23ae73"} checked={statusText.toLowerCase() === "active"} onChange={(status) => changeInboxSettingsStatus(notificationId, currStatus, "WhatsApp Notification")} />
                    </div>
                    <div color="" className="text-start m-0 p-0  w-100" /*onClick={() => toggleInboxSettings(notificationId)}*/
                         aria-expanded={selectedID === notificationId} aria-controls={`inbox-data-${notificationId}`}>
                        <div className={'header-title'}>
                            <div className={'title-info'}>
                                <h5 className="title-text m-0 p-0">{name}</h5>
                                <p className={'header-desc pt-2 hide'}>{description}</p>
                            </div>
                        </div>
                    </div>
                    <div className={'status-indicator mr-2'}>
                        {/*<p className={statusText.toLowerCase()}>{statusText.toLowerCase() === "active" ? "Enabled" : "Disabled"}</p>*/}
                        <span className={'editor'}>
                                    <div className={`le-clickable`} onClick={(e) => {editReplyMessage(notificationId)}}>{`Edit`}</div>
                                </span>
                    </div>
                </CardHeader>
                <Collapse isOpen={selectedID === notificationId} className={'settings-content'} data-parent="#accordion" id={`inbox-data-${notificationId}`}>
                    <CardBody>
                        <div>
                            <div className={'reply-message-modal'}>
                                {isNotification &&
                                <QuickReplyOperations
                                    key={randstr('quickrep_')}
                                    showActionModal={isMessageModalEnabled}
                                    quickReplyId={notificationId}
                                    toggleActionsModal={onNotificationMessageSave}
                                    type={"waNotification"}
                                    waOptions={waOptions}
                                    waTemplates={waTemplates}
                                    useForm={form}
                                    notificationFormData={notificationFormData}
                                />
                                }
                            </div>
                            <div className={'content-header'}>


                                <div className={'inbox-timing-setup'}>
                                    <div className={'d-flex-alone cursor-pointer'} >
                                        <span className={'timer'}>
                                            <div className={'timer-icon'}>
                                            <FontAwesomeIcon icon={faEnvelope} />
                                            </div>
                                        </span>
                                        <span className={'inbox-title'}>
                                            {name}
                                        </span>
                                        {/*<span className={'editor'}>
                                            <div className={'edit-icon cursor-pointer'}>
                                            <FontAwesomeIcon icon={faPencil} />
                                            </div>
                                        </span>*/}
                                    </div>
                                </div>
                            </div>
                            <div className={'content-data content-preview'}>
                                <span className="message-content" dir="auto">
                                    <div dangerouslySetInnerHTML={{ __html: messageText }} />
                                </span>

                            </div>
                            {/*<div className={'content-data content-preview'}>
                                    <Button  onClick={() => changeInboxSettingsStatus(notificationId, currStatus, "WhatsApp Notification")} color={statusText.toLowerCase() === "active" ? "danger" : "success"} size="lg" className="mt-4">
                                    {statusText.toLowerCase() === "active" ? "Disable" : "Enable"}
                                    </Button>
                            </div>*/}
                        </div>
                    </CardBody>
                </Collapse>
            </Card>
        </div>
    )
}

export default NotificationItem;
